<app-protocolo-envio
    [titulo]="titulo"
    [instrucoesEnvio]="instrucoesEnvio"
    [routerLinkPesquisaLote]="['/acompanhamento-processual/pesquisa']"
    [tipoConteudoArquivo]="tipoConteudoArquivo"
    [janelaEnvioAtual]="janelaAtual"
    [tipoArquivoAceito]="'csv'"
>
</app-protocolo-envio>
